import "./link.scss";
import { useNavigate } from "react-router-dom";

type LinkProps = {
    entities: Array<any>;
    text: any;
    title?: string;
    link: string;
    state?: object;
};

export default function Link({ entities, text, title, link, state }: LinkProps) {
    const navigate = useNavigate();

    return (
        <div
            className="link"
            title={title ?? undefined}
            onClick={() => navigate(link, state ? { state } : undefined)}
        >
            {text}
        </div>
    );
}
